<template>
  <tr v-bind:class="{'table-danger': slideWarning}">
    <!-- No file selected -->
    <td class="align-middle" v-if="!slideObject.file"></td>
    <td class="align-middle" v-if="!slideObject.file">No file selected</td>
    <td class="align-middle" v-if="!slideObject.file"></td>
    <!-- File selected -->
    <td v-if="slideObject.file && isNew"></td>
    <td class="align-middle" v-if="slideObject.file && !isNew">
      <b-button :disabled="disabled" @click="$emit('move-up')" size="sm" class="m-1">
        <fa-icon icon="arrow-up"/>
      </b-button>
      <b-button :disabled="disabled" @click="$emit('move-down')" size="sm" class="m-1">
        <fa-icon icon="arrow-down"/>
      </b-button>
    </td>
    <td class="align-middle" v-if="slideObject.file" width="100">
      <b-img :src="slideObject.file.thumb_url" fluid v-if="slideObject.file.type !== 'url'"></b-img>
      <b-embed type="iframe" :src="slideObject.file.path" fluid v-if="slideObject.file.type === 'url'"></b-embed>
    </td>
    <td class="align-middle file-name" v-if="slideObject.file">
      <span>{{slideObject.file.name}}</span>
    </td>

    <!-- Starts-ends -->
    <td class="align-middle time-picker" v-if="['playlists', 'weekly-playlists'].includes(this.playlistType)">
      <TimePicker v-if="!isNew" :time="slideObject.starts_at" :text="'From:'" />
      <TimePicker v-if="!isNew" :time="slideObject.ends_at" :text="'To:'" :type="'to'" />
    </td>
    <!-- Actions -->
    <td class="align-middle td-no-wrap">
      <b-button :disabled="disabled" @click="selectFile" variant="info" size="sm" class="m-1">
        <fa-icon icon="folder-open"/>
        Pick media
      </b-button>
      <b-button :disabled="disabled" v-if="!isNew" @click="$emit('remove-self')" variant="danger" size="sm" class="m-1">
        <fa-icon icon="trash"/>
      </b-button>
    </td>
  </tr>

</template>

<script>
import formsMixin from '@/mixins/forms';
import mediaMixin from '@/views/admin/media/mediaMixin';
import TimePicker from '@/components/TimePicker.vue';

export default {
  components: { TimePicker },
  mixins: [formsMixin, mediaMixin],
  data() {
    return {
      slideObject: {
        file_id: null,
        file: null,
        starts_at: { h: '09', m: '00', s: '00' },
        ends_at: { h: '20', m: '00', s: '00' },
      },
    };
  },
  props: {
    slide: {
      type: [Object],
      required: true,
    },
    isNew: {
      type: [Boolean],
      required: false,
      default: false,
    },
    disabled: {
      type: [Boolean],
      required: false,
      default: false,
    },
    playlistType: {
      type: [String],
      required: false,
      default: 'playlists',
      validator(v) {
        return ['playlists', 'loop-playlists', 'weekly-playlists'].indexOf(v) !== -1;
      },
    },
    orientation: {
      type: [Number],
      required: false,
      default: 0,
    },
  },
  created() {
    if (!this.isNew) {
      this.slideObject = this.slide;
    }
  },
  beforeUpdate() {
    if (!this.isNew) {
      this.slideObject = this.slide;
    }
  },
  methods: {
    selectFile() {
      this.$root.$emit('modal-show', {
        title: `Pick ${this.orientation ? 'portrait' : 'landscape'} files`,
        body: '',
        cbConfirm: (fileArray) => {
          fileArray.forEach((fileObj) => {
            this.slideObject.file = fileObj;
            this.slideObject.file_id = fileObj.id;
            if (this.isNew) {
              this.$emit('add-self', this.slideObject);
            }
          });
        },
        confirmText: 'OK',
        cancelText: 'Cancel',
        filePicker: true,
        multiPick: this.isNew,
        pickerFolders: false,
        orientation: this.orientation,
      });
    },
  },
  computed: {
    slideWarning() {
      return this.slideObject.file && this.slideObject.file.type !== 'url' && this.slideObject.file.portrait !== this.orientation;
    },
  },
};
</script>

<style lang="less" scoped>
tr td {
  img{
    max-width: 150px;
    max-height: 150px;
  }

  &.file-name{
    span{
      display: inline-block;
      max-width: 250px;
      line-height: 1.5em;
      max-height: 4.5em;
      word-wrap: break-word;
      overflow: hidden;
    }
  }

  &.time-picker{
    min-width: 180px;
  }
}
</style>
